import { LanguageCode } from "../../../customers/customerlanguages";

export const MachineTranslationService = {
  DEEPL: "DeepL",
  GOOGLE: "Google Translate",
  GPT: "GPT",
  MODERNMT: "ModernMT",
} as const;

export const MachineTranslationFormality = {
  prefer_less: "Less formal",
  prefer_more: "More formal",
} as const;

export const MachineTranslationDeeplModelType = {
  prefer_quality_optimized: "Better quality (slower)",
  latency_optimized: "Classic",
} as const;

export type MachineTranslationServiceType = keyof typeof MachineTranslationService;
export type MachineTranslationFormalityType = keyof typeof MachineTranslationFormality;
export type MachineTranslationDeeplModelType = keyof typeof MachineTranslationDeeplModelType;

export type MachineTranslationConfig = {
  language: LanguageCode;
  machine_translation_service: MachineTranslationServiceType;
  machine_translation_prompt?: number;
  machine_translation_formality?: MachineTranslationFormalityType;
  deepl_model_type?: MachineTranslationDeeplModelType;
};

export type MachineTranslationConfigWithSelection = MachineTranslationConfig & {
  isSelected: boolean;
};

export type MachineTranslationConfigGroup = {
  id: number;
  name: string;
  description: string;
  is_default: boolean;
  configs: MachineTranslationConfig[];
};
